<script setup>
import { ref } from 'vue';
import ContactsModal from './ContactsModal.vue';
import { openUrlWithFakeTag } from '@/Services/agendartMobileAppUtils';


const props = defineProps({
    web_site: Object,
    selfSchedulingLink: String
});


const color = ref(props.web_site.color)

// Open dialog
const isDialogOpen = ref(false);
const openDialog = () => { isDialogOpen.value = true; };
const closeDialog = () => { isDialogOpen.value = false; };

const openSelfScheduling = () => {
    openUrlWithFakeTag(props.selfSchedulingLink, '_blank');
}

</script>
<template>

    <!-- Schedule -->
    <section id="agendamento" aria-labelledby="schedule-appointment-heading" class="px-5 py-9 md:py-10" :style="{ background: color }">
        <div class="container mx-auto flex flex-col items-center gap-2 text-white">
            <h2 id="schedule-appointment-heading" class="text-center text-2xl font-bold md:text-3xl">{{ $t('schedule_appointment') }}</h2>
            <p class="text-center text-sm font-light md:text-base">{{ $t('contact_and_check_times') }}</p>
            <div class="mt-3 flex flex-col gap-3 sm:flex-row">
                <div v-if="selfSchedulingLink" class="flex flex-col gap-3 sm:flex-row">
                    <button @click="openDialog" class="rounded-full bg-white px-5 py-2.5 text-sm font-semibold" :style="{ color }">
                        {{ $t('contact') }}
                    </button>
                    <button @click="openSelfScheduling" class="rounded-full border border-white px-5 py-2.5 text-sm font-semibold text-white">
                        <i class="fa-regular fa-calendar mr-2" aria-hidden="true"></i>
                        {{ $t('schedule_now') }}
                    </button>
                </div>
                <div v-else>
                    <button type="button" @click="openDialog"
                        class="rounded-full bg-white px-5 py-2.5 text-sm font-semibold"
                        :style="{ color }">
                        {{ $t('contact') }}
                    </button>
                </div>

            </div>
        </div>
    </section>

    <ContactsModal :visible="isDialogOpen" @close="closeDialog" :web_site="web_site" :selfSchedulingLink="selfSchedulingLink"/>


</template>
